"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TimePeriod;
(function (TimePeriod) {
    // Unbekannt
    TimePeriod[TimePeriod["Unknown"] = 0] = "Unknown";
    // Minute
    TimePeriod[TimePeriod["Minute"] = 1] = "Minute";
    // Stunde
    TimePeriod[TimePeriod["Hour"] = 2] = "Hour";
    // Tag
    TimePeriod[TimePeriod["Day"] = 3] = "Day";
    // Woche
    TimePeriod[TimePeriod["Week"] = 4] = "Week";
    // Monat
    TimePeriod[TimePeriod["Month"] = 5] = "Month";
    // Quartal
    TimePeriod[TimePeriod["Quarter"] = 6] = "Quarter";
    // Halbjahr
    TimePeriod[TimePeriod["HalfYear"] = 7] = "HalfYear";
    // Jahr
    TimePeriod[TimePeriod["Year"] = 8] = "Year";
})(TimePeriod = exports.TimePeriod || (exports.TimePeriod = {}));
